const Title = () => {
    return <h1 className="Title">Регистрация в Кафетерии льгот</h1>;
}

export default Title;